import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TimeTypeinPage } from './time-typein.page';

const routes: Routes = [
  {
    path: '',
    component: TimeTypeinPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TimeTypeinPageRoutingModule {}
